import PropTypes from 'prop-types';
import React from 'react'
import {
  isMobile
} from "react-device-detect";
import { Button } from 'reactstrap';
import { Link } from 'react-router-dom' 

const propTypes = {
  gender: PropTypes.string.isRequired
};

const styles = {
 
  buttonStyle: {
    width:'23vw',
    margin:'5px',
    padding: '5px 5px ',    
    marginTop: "20px",
    background:'#000',    
    color:'#FfF',
    border: '0px', 
    borderRadius:'6px'
  }
}

const ButtonLinkGenderPage = ({gender, content=gender}) => {

  return <Link to={`/${gender}`} className="text-white m-2"><Button size="md"  style={{background:'#000'}} >{content}</Button></Link>
}

ButtonLinkGenderPage.propTypes = propTypes;

export default ButtonLinkGenderPage


// WEBPACK FOOTER //
// ./src/components/Button-link-gender-page.js